import { render, staticRenderFns } from "./iventarisP2L.vue?vue&type=template&id=d9ea3e5a&"
import script from "./iventarisP2L.vue?vue&type=script&lang=js&"
export * from "./iventarisP2L.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports